import * as yup from 'yup';

export const storageValidations = yup.object().shape({
  quantityToUse: yup
    .string()
    .required('A quantidade é obrigatória')
    .nullable(),
  minQuantityToUse: yup
    .string()
    .required('O estoque mínimo é obrigatório')
    .nullable()
});